import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Dialog,
  DialogPanel,
  Popover,
  PopoverButton,
  PopoverPanel,
  PopoverGroup,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import {
  Bars3Icon,
  XMarkIcon,
  AdjustmentsHorizontalIcon,
  Cog8ToothIcon,
  CpuChipIcon,
  CubeIcon,
  UserGroupIcon,
  CheckIcon,
  ChevronUpDownIcon,
  ChevronDownIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../hoc/AuthContext"; // Adjust path as needed
import variable from "../../lib/variable";
import { fetchProductList, mapProductForHeader } from "../../apiService/product.service";

const navigation = [
  {
    name: "Features",
    href: "/features/header",
    icon: AdjustmentsHorizontalIcon,
    subnav: [
      { name: "Header", href: "/features/header" },
      { name: "Footer", href: "#" },
      { name: "Events", href: "#" },
      { name: "Chat Tag", href: "/features/chat-tag" },
      { name: "Manage City", href: "#" },
      { name: "Manage product", href: "#" },
      { name: "Manage Category", href: "#" },
      { name: "Script Manager", href: "#" },
      { name: "Promotional Space", href: "#" },
      { name: "Users", href: "#" },
    ],
  },
  {
    name: "Products",
    href: "/products/astrology/horoscope",
    icon: CubeIcon,
    subnav: [
      { name: "Astrology", href: "/products/astrology/horoscope" },
      { name: "Khojle Affiliate", href: "#" },
      { name: "Affiliate", href: "#" },
      { name: "Interactive", href: "#" },
      { name: "Short video", href: "#" },
      { name: "Videos", href: "#" },
      { name: "Product Setting", href: "#" },
      { name: "Subscription", href: "#" },
    ],
  },
  {
    name: "Services",
    href: "/services/notification/topics",
    icon: Cog8ToothIcon,
    subnav: [
      {
        name: "Notification Campaigns",
        href: "/services/notification/list",
        accessUrl: "services/notification/list",
      },
      // { name: "Recommended Product", href: "#" },
      // { name: "Engagement", href: "#" },
      // { name: "Ad Manager", href: "#" },
      {
        name: "Podcast",
        href: "/services/podcast/listing",
        accessUrl: "services/podcast/listing",
      },
      {
        name: "ePaper Editions",
        href: "/services/epaper/editions",
        accessUrl: "services/epaper/editions",
      },
      {
        name: "Loyalty Program",
        href: "/services/loyalty-program",
        accessUrl: "services/loyalty-program",
      },
      {
        name: "Loyalty Offers",
        href: "/services/loyalty-offers",
        accessUrl: "services/loyalty-offers",
      },
      {
        name: "prebid",
        href: "/services/prebidAds/dashboard",
        accessUrl: "services/prebidAds/dashboard",
      },
    ],
  },
  {
    name: "AI Hub",
    href: "/ai-hub/webstories/listing",
    icon: CpuChipIcon,
    subnav: [
      { name: "Ai Article", href: "/ai-article/ai-article" },
      { name: "Translation", href: "/ai-hub/Translation" },
      { name: "Webstories", href: "/ai-hub/webstories/listing" },
    ],
  },
  {
    name: "CDP",
    href: "/cdp/anonymous",
    icon: UserGroupIcon,
    subnav: [
      { name: "Behaviour", href: "/cdp/anonymous" },
      { name: "Sign-Up", href: "/cdp/registrations" },
      // { name: "Subscription", href: "/cdp/subscription" },
      { name: "Subscription Transactions", href: "/cdp/subscription/transactions" },
      { name: "Subscription Metrics", href: "/cdp/subscription/metrics" },
      { name: "Tickets", href: "/cdp/support/tickets" },
      { name: "Customers", href: "/cdp/customers" },
    ],
  },
];
const userNavigation = [
  { name: "My Account", href: "#" },
  { name: "Change Password", href: "#" },
  { name: "Logout", href: "/login?logout=1" },
];

function LayoutHeader(props) {
  const [productCatalog, setProductCatalog] = useState([]);
  const [displayDomain, setDisplayDomain] = useState([]);
  const [selected, setSelected] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { authUserData, selectedDomain, isAuthenticated, setSelectedDomain } =
    useContext(AuthContext);

  const saveDomainToStorage = (domainObj) => {
    if (!domainObj || !authUserData?.productslist) return;

    const val = authUserData?.productslist?.find(
      (el) => el.domain_url == domainObj.domain_url
    );
    setSelectedDomain(val);

    localStorage.setItem(
      variable.DEFAULT_DOMAIN,
      domainObj.domain_url || domainObj.id
    );
  };

  useEffect(() => {
    let cancelled = false;

    const loadProducts = async () => {
      try {
        const productList = await fetchProductList();
        if (!cancelled) {
          setProductCatalog(productList);
        }
      } catch (error) {
        console.error("Failed to load product list", error);
      }
    };

    if (isAuthenticated) {
      loadProducts();
    }

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  useEffect(() => {
    const userProducts = (authUserData?.productslist || []).map(mapProductForHeader);
    const visibleProducts = userProducts.length
      ? productCatalog.length
        ? productCatalog.filter((product) =>
            userProducts.some((userProduct) => String(userProduct.id) === String(product.id))
          )
        : userProducts
      : productCatalog;

    const productsToShow = visibleProducts.length ? visibleProducts : userProducts;
    setDisplayDomain(productsToShow);

    if (selectedDomain) {
      const match = productsToShow.find((product) => String(product.id) === String(selectedDomain.id));
      setSelected(match || mapProductForHeader(selectedDomain) || productsToShow[0] || null);
      return;
    }
    setSelected(productsToShow[0] || null);
  }, [productCatalog, authUserData?.productslist, selectedDomain]);

  const handleDomainChange = (newDomain) => {
    setSelected(newDomain);
    saveDomainToStorage(newDomain);
  };

  return (
    <header className="inset-x-0 w-full px-4 lg:px-0 lg:max-w-7xl m-auto top-0 z-50 flex h-20 lg:h-24 relative z-10">
      <div className="mx-auto flex w-full items-center justify-between">
        <div className="flex flex-1 items-center">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2 p-3 md:hidden"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-5 w-5 text-gray-900" />
          </button>
          <a href="/">
            <svg className="h-6 w-16 ml-2 sm:h-8 sm:w-20">
              <use href="#wms"></use>
            </svg>
          </a>
        </div>

        {props.noheader !== "noheader" && (
          <nav className="hidden md:flex md:gap-x-6 md:text-sm/6 md:font-bold md:text-gray-700">
            <PopoverGroup className="hidden lg:flex lg:gap-x-8">
              {navigation.map((item, itemIdx) => (
                <Popover className="relative" key={itemIdx}>
                  <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900 outline-none">
                    {item.name}
                    {item.subnav && (
                      <ChevronDownIcon
                        aria-hidden="true"
                        className="h-4 w-4 flex-none text-gray-400"
                      />
                    )}
                  </PopoverButton>

                  {item.subnav && (
                    <PopoverPanel
                      transition
                      className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-xs overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                      <div className="py-4">
                        {item.subnav.map((sub) => (
                          <div
                            key={sub.name}
                            className="group relative flex rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                          >
                            <div className="flex-auto">
                              <a
                                href={sub.href}
                                className="block text-sm font-medium text-gray-900 px-4"
                              >
                                {sub.name}
                                <span className="absolute inset-0" />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </PopoverPanel>
                  )}
                </Popover>
              ))}
            </PopoverGroup>
          </nav>
        )}

        {/* Domain Selector + User Menu */}
        {isAuthenticated ? (
          <div className="flex flex-1 items-center justify-end gap-x-2">
            <Listbox value={selected} onChange={handleDomainChange}>
              {({ open }) => (
                <>
                  <div className="relative">
                    <ListboxButton className="relative w-40 lg:w-52 cursor-default rounded-full bg-white py-2.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 text-xs sm:text-sm">
                      <span className="flex items-center">
                        {selected ? (
                          <>
                            {selected.avatar ? (
                              <img
                                alt=""
                                src={selected.avatar}
                                className="h-5 w-5 shrink-0 rounded-full"
                              />
                            ) : null}
                            <span className="ml-3 block truncate">
                              {selected.name}
                            </span>
                          </>
                        ) : (
                          <span className="ml-3 block truncate text-gray-400">
                            Loading...
                          </span>
                        )}
                      </span>
                      <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                        <ChevronUpDownIcon
                          aria-hidden="true"
                          className="h-5 w-5 text-gray-400"
                        />
                      </span>
                    </ListboxButton>

                    <ListboxOptions
                      transition
                      className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-2xl bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:opacity-0 transition duration-100 ease-in sm:text-sm"
                    >
                      {displayDomain.map((person) => (
                          <ListboxOption
                            key={person.id}
                            value={person}
                            className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-red-600 data-[focus]:text-white"
                          >
                            <div className="flex items-center">
                              {person.avatar ? (
                                <img
                                  alt=""
                                  src={person.avatar}
                                  className="h-5 w-5 shrink-0 rounded-full bg-white"
                                />
                              ) : null}
                              <span className="ml-3 block truncate text-xs sm:text-sm font-normal group-data-[selected]:font-semibold">
                                {person.name}
                              </span>
                            </div>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-red-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                              <CheckIcon
                                aria-hidden="true"
                                className="h-5 w-5"
                              />
                            </span>
                          </ListboxOption>
                        ))}
                    </ListboxOptions>
                  </div>
                </>
              )}
            </Listbox>

            {/* User Profile Menu */}
            <Menu as="div" className="relative ml-1 sm:ml-3">
              <div>
                <MenuButton className="relative h-10 w-10 flex rounded-full bg-slate-50 text-sm focus:outline-none focus:ring-2 outline-none focus:ring-offset-2">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <UserIcon
                    aria-hidden="true"
                    className="h-10 w-10 rounded-full border p-2"
                  />
                </MenuButton>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-2xl overflow-hidden bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                {userNavigation.map((item) => (
                  <MenuItem key={item.name}>
                    <a
                      href={item.href}
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-slate-100"
                    >
                      {item.name}
                    </a>
                  </MenuItem>
                ))}
              </MenuItems>
            </Menu>
          </div>
        ) : null}
      </div>

      {/* Mobile Menu */}
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">WMS</span>
              <svg className="h-6 w-16 sm:h-8 sm:w-20">
                <use href="#wms"></use>
              </svg>
            </a>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item, itemIdx) => (
                  <Disclosure as="div" className="-mx-3" key={itemIdx}>
                    <DisclosureButton className="group text-sm flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 font-semibold text-gray-900 hover:bg-gray-50">
                      {item.name}
                      {item.subnav && (
                        <ChevronDownIcon
                          aria-hidden="true"
                          className="h-5 w-5 flex-none group-data-[open]:rotate-180"
                        />
                      )}
                    </DisclosureButton>
                    {item.subnav && (
                      <DisclosurePanel className="mt-2 space-y-2">
                        {item.subnav.map((sub) => (
                          <DisclosureButton
                            key={sub.name}
                            as="a"
                            href={sub.href}
                            className="block rounded-lg py-2 pl-6 pr-3 text-xs font-semibold text-gray-900 hover:bg-gray-50"
                          >
                            {sub.name}
                          </DisclosureButton>
                        ))}
                      </DisclosurePanel>
                    )}
                  </Disclosure>
                ))}
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}

export default LayoutHeader;
